import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Animation utilities
export const textReveal = (element, delay = 0) => {
    if (!element) return;

    element.style.opacity = '0';
    element.style.transform = 'translateY(20px)';
    element.style.transition = 'opacity 0.8s ease, transform 0.8s ease';

    setTimeout(() => {
        element.style.opacity = '1';
        element.style.transform = 'translateY(0)';
    }, delay);
};

export const staggerChildren = (parentElement, childSelector, staggerDelay = 100) => {
    if (!parentElement) return;

    const children = parentElement.querySelectorAll(childSelector);
    children.forEach((child, index) => {
        child.style.opacity = '0';
        child.style.transform = 'translateY(20px)';
        child.style.transition = 'opacity 0.8s ease, transform 0.8s ease';

        setTimeout(() => {
            child.style.opacity = '1';
            child.style.transform = 'translateY(0)';
        }, index * staggerDelay);
    });
};

export const fadeInUp = (element, delay = 0) => {
    if (!element) return;

    gsap.from(element, {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power3.out',
        delay: delay / 1000,
        onComplete: () => {
            gsap.set(element, { clearProps: 'all' });
        }
    });
};

export const scaleIn = (element, delay = 0) => {
    if (!element) return;

    gsap.from(element, {
        duration: 1,
        scale: 0.8,
        opacity: 0,
        ease: 'back.out(1.7)',
        delay: delay / 1000,
        onComplete: () => {
            gsap.set(element, { clearProps: 'all' });
        }
    });
};

export const slideIn = (element, direction = 'left', delay = 0) => {
    if (!element) return;

    const x = direction === 'left' ? -50 : 50;

    gsap.from(element, {
        duration: 1,
        x: x,
        opacity: 0,
        ease: 'power3.out',
        delay: delay / 1000,
        onComplete: () => {
            gsap.set(element, { clearProps: 'all' });
        }
    });
};

export const setupScrollAnimations = (element, trigger = null) => {
    if (!element) return;

    gsap.from(element, {
        scrollTrigger: {
            trigger: trigger || element,
            start: 'top 80%',
            toggleActions: 'play none none reverse'
        },
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power3.out'
    });
}; 